// Import Dependencies
import React from 'react';

import ErrorView from '~/views/ErrorView';

export default class ErrorBoundary extends React.Component {
    state = {
        hasError: false
    };

    componentDidCatch() {
        // Display loading spinner
        this.setState({ hasError: true });
    }

    render() {
        return this.state.hasError ?
            <ErrorView />
            :
            this.props.children;
    }
}
